module.exports = __webpack_public_path__ + "static/media/TECHM.70482406.txt";